export default __webpack_public_path__ + "static/media/skyground-dark.0f53940a.svg";